var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctCustom, FctCustomArray, FctValue, FctValueListN, paramsSchemas, } from '../../../generics/FctParams';
var pluginType = {
    view: 'GETTER',
    payable: 'ACTION',
    nonpayable: 'ACTION',
    pure: 'GETTER',
};
var generateFunctionSignature = function (name, inputs) {
    var params = inputs.map(function (input) { return input.type; }).join(',');
    return "".concat(name, "(").concat(params, ")");
};
var getNumber = function (value) {
    var parsedValue = value.match(/\d+/);
    return parsedValue && parsedValue.length ? parsedValue[0] : undefined;
};
var isArrayType = function (value) {
    var parsedValue = value.match(/\[[^\]]*\]/);
    return parsedValue && parsedValue.length ? Boolean(parsedValue[0]) : false;
};
var is256Array = function (value) {
    if (!value.includes('256'))
        return;
    if (!value.includes('['))
        return;
    if (!value.includes(']'))
        return;
    return true;
};
var generateParams = function (inputs, isOutput, errors, pluginName) {
    return inputs.reduce(function (acc, input, index) {
        var _a, _b;
        var type = input.type;
        var name = input.name;
        var ioType = isOutput ? 'output' : 'input';
        if (!name) {
            errors.set(pluginName, "One of the ".concat(ioType, "s has no name using key ").concat(type, " instead"));
            name = type;
        }
        if (!type) {
            throw new Error("".concat(ioType, " ").concat(name, " has no type. This plugin will not be added to the list"));
        }
        if (!isOutput && (type === 'tuple' || type === 'tuple{}')) {
            if (!input.components) {
                throw new Error("".concat(ioType, " ").concat(name, " is a tuple, but has no components. This plugin will not be added to the list"));
                return acc;
            }
            return __assign(__assign({}, acc), (_a = {}, _a["".concat(name, "_").concat(type)] = generateParams(input.components, isOutput, errors, name), _a));
        }
        var Parameter = is256Array(type)
            ? FctValueListN
            : paramsSchemas.find(function (Item) {
                var newItem = new Item({});
                return newItem.fctType === type;
            });
        var classInput = isOutput ? { innerIndex: index } : {};
        var paramInstance;
        if (Parameter) {
            paramInstance = new Parameter(classInput);
            paramInstance._fctType = type;
        }
        else {
            paramInstance = isArrayType(type) ? new FctCustomArray(classInput) : new FctCustom(classInput);
            paramInstance._fctType = type;
        }
        if (isOutput && type.includes("[]")) {
            var oName = name.replace("[]", '');
            var oType_1 = type.replace("[]", '');
            var Parameter_1 = paramsSchemas.find(function (Item) {
                var newItem = new Item({});
                return newItem.fctType === oType_1;
            });
            var ParamConstructor = void 0;
            if (Parameter_1) {
                ParamConstructor = Parameter_1;
            }
            else {
                ParamConstructor = FctCustom;
            }
            var params = {};
            for (var n = 0; n < 5; n++) {
                var innerIndex = n + 2;
                var paramInstance_1 = new ParamConstructor({ innerIndex: innerIndex, innerType: type });
                paramInstance_1._fctType = oType_1;
                var key = n > 0 ? "".concat(oName, "_").concat(n) : oName;
                params[key] = paramInstance_1;
            }
            return __assign(__assign({}, acc), params);
        }
        return __assign(__assign({}, acc), (_b = {}, _b[name] = paramInstance, _b));
    }, {});
};
export var getPluginsFromABI = function (_a) {
    var abi = _a.abi, protocol = _a.protocol, chainId = _a.chainId, contractAddress = _a.contractAddress, pluginName = _a.pluginName;
    var supportedContracts = [{ chainId: Number(chainId), address: contractAddress }];
    var errors = new Map();
    var plugins = abi
        .filter(function (item) { return item.type === 'function'; })
        .map(function (item) {
        var name = item.name, inputs = item.inputs, outputs = item.outputs, stateMutability = item.stateMutability;
        if (!name) {
            errors.set('unknown', 'One of the functions has no name. This plugin will not be added to the list');
            return undefined;
        }
        if (!stateMutability) {
            errors.set(name, "Function ".concat(name, " has no stateMutability. This plugin will not be added to the list"));
            return undefined;
        }
        try {
            var transferInputs_1 = stateMutability === 'payable'
                ? {
                    to: new FctAddress({}),
                    value: new FctValue({}),
                }
                : {
                    to: new FctAddress({}),
                };
            var pluginInputs_1 = inputs && inputs.length ? generateParams(inputs, false, errors, name) : {};
            var pluginOutputs_1 = outputs && outputs.length ? generateParams(outputs, true, errors, name) : {};
            var params = {
                name: pluginName ? pluginName : name,
                description: generateFunctionSignature(name, inputs || []),
                plugin: createPlugin({
                    protocol: protocol,
                    type: pluginType[stateMutability],
                    method: name,
                    name: pluginName,
                    supportedContracts: supportedContracts,
                    getParams: function () { return ({
                        // @ts-expect-error: value not undefined
                        input: __assign(__assign({}, transferInputs_1), { methodParams: pluginInputs_1 }),
                        output: pluginOutputs_1,
                    }); },
                    initParams: {
                        to: supportedContracts.length === 1 ? supportedContracts[0].address : undefined,
                        value: '0',
                    },
                }),
            };
            return params;
        }
        catch (e) {
            console.error({ catchederror: e });
            errors.set(name, e.message);
            return undefined;
        }
    })
        .filter(function (plugin) { return Boolean(plugin); });
    return {
        errors: errors,
        plugins: plugins,
    };
};
